/** Used as an action type when a calculator value is changed */
export const UPDATE_CALCULATOR = 'UPDATE_CALCULATOR'

/** Used as an action type when calculator values change */
export const BATCH_UPDATE_CALCULATOR = 'BATCH_UPDATE_CALCULATOR'

/** Used as an action when starting the update distance on interval saga */
export const UPDATE_DISTANCE_ON_INTERVAL = 'UPDATE_DISTANCE_ON_INTERVAL'

/** Used as an action when stopping the update distance interval */
export const CLEAR_UPDATE_DISTANCE_ON_INTERVAL = 'CLEAR_UPDATE_DISTANCE_ON_INTERVAL'



// WEBPACK FOOTER //
// ./src/actions/calculatorActionTypes.js